import { useListarTorres } from "services/api";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";
import EspelhoVendasModal from "components/dialogCommon/templates/EspelhoVendasModal";
import ModalFulscreen from "components/ModalFullscreen";
import { useListarBandeira } from "services/api/DadosComum/listar-bandeiras";
import { useListarEmpreendimentos2Filter } from "services/api/AppWeb_Empreendimento2/empreendimentosfilter";
import { useGetStandEspelho } from "services/products/getStandEspelho";
import SelectComponent from "../../../../components/selectAutoCompleteG";
import * as Styles from "./style";
import * as SVGIcons from "../../../../assets/iconsSVG";

interface Props {
  idCorretor2013?: string;
}

interface ProductSelectProps {
  value: string;
  label: string;
  codigoSap: string;
}

interface SelectProps {
  value: string;
  label: string;
}

interface DataProps {
  bandeira: SelectProps;
  bloco: SelectProps;
  produto: ProductSelectProps;
  blocosData: any;
}

export default function ModalEspelho(props: Props) {
  const history = useHistory();
  const [block, setBlock] = useState<any>(null);
  const [product, setProduct] = React.useState<any>(null);
  // const [espelhoLink, setEspelhoLink] = useState<string>(
  //   `https://pvcrm.cyrela.com.br/secretaria/FrmEmpreendimento.aspx?userid=${props.idCorretor2013}&tipoUrl=6`
  // );
  const [espelhoVendasModal, setEspelhoVendasModal] = useState(false);
  const [bandeira, setBandeira] = useState<any>(null);

  const { data: bandeirasData, status: bandeirasStatus } = useListarBandeira();

  const {
    data: produtosData,
    refetch: produtosRefetch,
    status: produtosStatus,
    isFetching: produtosFetching,
  } = useListarEmpreendimentos2Filter({
    idBandeira365: bandeira?.value || null,
    espelhoVendas: true,
  });

  const {
    data: blocosData,
    refetch: blocosRefetch,
    status: blocosStatus,
    isFetching: blocosFetching,
  } = useListarTorres({
    idEmpreendimento: product?.value,
    queryKey: "listar-blocos",
  });

  const { data: standEspelhoData, isFetching: isFetchingStandEspelho } =
    useGetStandEspelho({
      idEmpreendimento: product?.value || null,
      enabled: !!product?.value,
    });

  // useEffect(() => {
  //   if (block && block.value && props.product) {
  //     setEspelhoLink(
  //       `https://pvcrm.cyrela.com.br/secretaria/FrmEspelhoVenda.aspx?id=${props.product}&ambiente=6&idBloco=${block.value}&sec=N&dt=N`
  //     );
  //   } else {
  //     setEspelhoLink(
  //       `https://pvcrm.cyrela.com.br/secretaria/FrmEmpreendimento.aspx?userid=${props.idCorretor2013}&tipoUrl=6`
  //     );
  //   }
  // }, [block, props.product]);

  // React.useEffect(() => {
  //   blocosRefetch();
  //   setBlock([]);
  // }, [props.product]);

  const newData: DataProps = {
    bandeira: bandeira || { value: "", label: "" },
    produto: {
      value: product?.value || "",
      label: product?.label || "",
      codigoSap: product?.codigoSap || "",
    },
    bloco: block || { value: "", label: "" },
    blocosData,
  };

  useEffect(() => {
    produtosRefetch();
  }, []);

  const handleChangeProduct = async (event: any) => {
    await setProduct(event);
    blocosRefetch();
    setBlock(null);
  };

  const handleChangeBandeira = async (event: any) => {
    await setBandeira(event);
    produtosRefetch();
    setProduct(null);
    setBlock(null);
  };

  const handleOpenStandEspelho = () => {
    if (standEspelhoData) {
      const standEspelho = standEspelhoData?.data?.[0]?.standEspelho;
      if (standEspelho && product) {
        const params = new URLSearchParams({
          url: standEspelho,
          produtoNome: product?.label || "",
          produtoCodigo: product?.codigoSap || "",
        });
        history.push(`/stand-espelho?${params.toString()}`);
      } else {
        toast.error("Stand espelho não encontrado para este empreendimento.");
      }
    }
  };

  return (
    <>
      <Styles.Container>
        <SelectComponent
          borderRadius="8px"
          data={
            bandeirasStatus === "success"
              ? bandeirasData?.map((item: any) => ({
                  label: item?.nome,
                  value: item?.id,
                }))
              : []
          }
          label="Filtrar bandeira"
          value={bandeira}
          onChange={(event: { label: string; value: string }) => {
            handleChangeBandeira(event);
          }}
        />
        <Styles.SpaceY space={20} />
        <SelectComponent
          borderRadius="8px"
          data={
            produtosStatus === "success"
              ? produtosData?.data?.map((item: any) => ({
                  label: item?.nome,
                  value: item?.id,
                  codigoSap: item?.codigoSap,
                }))
              : []
          }
          label="Produtos"
          value={product}
          disabled={produtosFetching}
          onChange={(event: { label: string; value: string }) => {
            handleChangeProduct(event);
          }}
        />
        <Styles.SpaceY space={20} />
        <SelectComponent
          borderRadius="8px"
          data={
            blocosStatus === "success"
              ? blocosData?.data?.map((item: any) => ({
                  label: item?.nome,
                  value: item?.id,
                }))
              : []
          }
          label="Blocos"
          value={block}
          disabled={blocosFetching || !product}
          onChange={(event: { label: string; value: string }) => {
            setBlock(event);
          }}
        />
        <Styles.SpaceY space={40} />
        <Styles.GradientButton
          disabled={!product || !block}
          onClick={() => setEspelhoVendasModal(true)}
        >
          Abrir espelho <SVGIcons.SharedIcon style={{ marginLeft: 8 }} />
        </Styles.GradientButton>
        <Styles.SpaceY space={20} />
        {standEspelhoData?.data?.[0]?.standEspelho !== null && (
          <Styles.ButtonStand
            disabled={
              !product ||
              isFetchingStandEspelho ||
              !standEspelhoData?.data?.[0]?.standEspelho
            }
            onClick={handleOpenStandEspelho}
          >
            Stand espelho <SVGIcons.SharedIcon style={{ marginLeft: 8 }} />
          </Styles.ButtonStand>
        )}
        <Styles.SpaceY space={20} />
        <ModalFulscreen
          open={espelhoVendasModal}
          setOpenModal={() => setEspelhoVendasModal(true)}
          onClose={() => setEspelhoVendasModal(false)}
        >
          <EspelhoVendasModal
            data={newData}
            onClose={() => setEspelhoVendasModal(false)}
            idLead={undefined}
            openOpportunityForm={() => {}}
          />
        </ModalFulscreen>
      </Styles.Container>
    </>
  );
}
